<template>
  <div>
    <div class="content">
      <div class="content-c5">
        <div class="cont-share m-t-20">
          <p class="m-l-10 f-w f-t-15 wihte-color">{{ $lang.common_txt57 }}</p>
          <div v-if="inviteCode" class="d-flex">
            <div class="content-c3--b m-l-10">
              <p>{{ inviteCode }}</p>
              <p class="fz-txt" @click="copyText">
                {{ $lang.common_txt56 }}
              </p>
            </div>
          </div>
          <p class="t-c m-t-10 f-w wihte-color">{{ $lang.common_txt58 }}</p>
          <div
            class="d-flex m-l-10 m-t-10"
            v-drag-scroll
            style="
              overflow-x: auto;
              cursor: grab;
              user-select: none; /* 防止选中文本 */
              white-space: nowrap;
              min-width: 245px;
            "
          >
            <div
              class="m-r-10 t-c"
              v-for="(item, index) in shareList"
              :key="index"
              @click="shareContent(index)"
            >
              <img :src="item.img" width="25" />
              <p style="font-size: 9px" class="t-c m-t-5 wihte-color">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
        <!-- <p class="font-color m-t-10">
          {{ $lang.share_txt2 }}
        </p> -->
        <!-- <img
          src="../../assets/img/share/share_list.png"
          width="100%"
          @click="shareContent"
        /> -->
      </div>
      <div
        style="
          background-image: linear-gradient(180deg, #ffffff 0%, #ebf6ff 100%);
          box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
          border-radius: 12px;
          margin-top: 10px;
          padding: 20px 0 10px;
        "
      >
        <p class="t-c f-t-15 f-w" style="color: #0077bb">
          {{ $lang.common_txt34 }}
        </p>
        <img
          class="m-t-10"
          src="../../assets/img/share/share-fx.png"
          width="100%"
          style="border-radius: 12px"
        />
      </div>
      <!-- 
      <div class="d-flex m-t-10">
        <img src="../../assets/img/home/mine-left.png" width="30" />
        <span class="m-l-5 f-t-15 f-w">Direct Commission</span>
      </div> -->

      <div class="content-c3 m-t-10">
        <p class="d-flex content-c3-xx">
          <img
            src="../../assets/img/common/0021_qun_bai.png"
            width="20"
            class="m-r-5"
          />
          <span class="wihte-color">{{ $lang.common_txt141 }}</span>
        </p>
        <div class="content-c3--t">
          <p>{{ $lang.common_txt48 }}</p>
          <p>{{ $lang.common_txt49 }}</p>
          <p>{{ $lang.common_txt50 }}</p>
        </div>
        <div
          class="content-c3--t2"
          v-for="(item, index) in InitDate"
          :key="index"
          :style="
            (index + 1) % 2 === 0
              ? {}
              : { backgroundColor: 'rgba(255, 255, 255, 0.02)' }
          "
        >
          <p>
            {{ item.vipLevel }}
          </p>
          <p>
            {{ item.reward }}
          </p>
          <p class="info2-color">
            {{ item.ratino }}
          </p>
        </div>
      </div>
      <div
        class="d-flex f-t-15 f-w m-t-10 m-b-10"
        style="justify-content: center"
      >
        <span class="share-bot-l"></span>
        <span>{{ $lang.common_txt35 }}</span>
        <span class="share-bot-r"></span>
      </div>

      <div v-html="$lang.common_txt36" class="l-h-20"></div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import { Init } from '@/api/common'
export default {
  name: 'ShareOnes',
  // eslint-disable-next-line vue/no-unused-components
  components: { VueQr },
  data() {
    return {
      inviteCode: '',
      shareList: [
        {
          img: require('@/assets/img/common/fenxiang.png'),
          name: 'Share'
        },
        {
          img: require('@/assets/img/common/img_wa.png'),
          name: 'WhatsApp'
        },
        {
          img: require('@/assets/img/common/img_tg.png'),
          name: 'Telegram'
        },
        {
          img: require('@/assets/img/common/huohua.png'),
          name: 'Instagram'
        },
        {
          img: require('@/assets/img/common/youtub.png'),
          name: 'Youtobe'
        },
        {
          img: require('@/assets/img/common/img_facebook.png'),
          name: 'Facebook'
        },
        {
          img: require('@/assets/img/common/douyin.png'),
          name: 'Tiktok'
        },
        {
          img: require('@/assets/img/common/img_x.png'),
          name: 'X'
        }
      ],
      InitDate: [
        { vipLevel: '1', reward: '1', ratino: '0.50%' },
        { vipLevel: '2', reward: '300.000', ratino: '1.50%' },
        { vipLevel: '3', reward: '900.000', ratino: '2.00%' },
        { vipLevel: '4', reward: '1.500.000', ratino: '4.00%' },
        { vipLevel: '5', reward: '3.000.000', ratino: '5.00%' }
      ]
    }
  },
  mounted() {
    this.Init()
  },
  methods: {
    shareContent(i) {
      if (i === 0) {
        if (navigator.share) {
          navigator
            .share({
              title: 'OT.GAME',
              text: 'OT.GAME',
              url: this.inviteCode
            })
            .catch((err) => {
              console.error(err)
            })
        } else {
          alert('Your browser does not support the Web Share API.')
        }
      } else if (i === 1) {
        window.open(`https://api.whatsapp.com/`, '_blank')
      } else if (i === 2) {
        window.open(`https://t.me/`, '_blank')
      } else if (i === 3) {
        window.open(`https://www.instagram.com/`, '_blank')
      } else if (i === 4) {
        window.open(`https://www.youtube.com/`, '_blank')
      } else if (i === 5) {
        window.open(`https://www.facebook.com/`, '_blank')
      } else if (i === 6) {
        window.open(`https://www.tiktok.com/`, '_blank')
      } else if (i === 7) {
        window.open(`https://x.com/`, '_blank')
      }
    },
    async Init() {
      const data = await Init()
      if (data.status === 'ok') {
        this.inviteCode =
          window.location.origin +
          '/' +
          localStorage.getItem('country') +
          '/home?id=' +
          data.content.inviteCode
      }
    },
    copyText() {
      const textarea = document.createElement('textarea')
      textarea.value = this.inviteCode
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$toast({
        message: this.$lang.Sucesso,
        icon: 'success'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 0 5% 18%;
  // background: url(../../assets/img/common/sub_bg.png);
  // background-size: cover;
  // background-repeat: repeat;
}
.content-c2 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
  background-image: url('../../assets/img/bonus/cashback_rate_vip.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 5px 10px;
  font-weight: bold;
}
.content-c2s {
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
  background-image: url('../../assets/img/bonus/cashback_rate_vip.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 380px; /* 或者指定具体的宽度 */
  padding: 5px 10px;
  font-weight: bold;
}

.content-c3--qr {
  border-radius: 10px 10px 0 0;
}
.content-c3--qrt {
  color: #472600;
  background: linear-gradient(to bottom, #fae87d, #f7d975, #f4c56a, #f0ab5d);
  text-align: center;
  border-radius: 0 0 8px 8px;
  padding: 5px 0 3px;
  font-weight: bold;
  margin-top: -5px;
}
.content-c3--b {
  margin-top: 5px;
  display: flex;
  color: rgba(255, 255, 255, 0.65);
  background: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 7px 10px;
  line-height: 23px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.content-c5 {
  margin-top: 10px;
  border-radius: 13px;
}
.content-c6 {
  padding: 0px 0px;
}
.content-c6--b {
  align-items: center;
  display: flex;
  background: #eef7f4;
  border-radius: 13px;
  padding: 10px 5px;
  width: 100%;
  margin-bottom: 10px;
}
.content-c7 {
  // border: 1px solid #686869;
  // border-radius: 13px;
  // padding: 20px 15px;
  // margin-top: 15px;
  line-height: 20px;
  color: @font-color;
  // font-size: 15px;
}
.content-c3 {
  background-image: linear-gradient(180deg, #ffffff 0%, #ebf6ff 100%);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  // border: 1px solid rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 12px;
  padding: 10px 15px;
}
.content-c3--t2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  background: rgba(0, 0, 0, 0.04);
}
.content-c3--t2 p {
  width: 33%;
  text-align: center;
}
.content-c3 :last-child {
  border-radius: 0 0 12px 12px !important;
}

.content-c3--t {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
  padding: 3.2% 6% 3.2% 13%;
  background: rgba(0, 0, 0, 0.04);
}
.cont-share {
  border-radius: 12px;
  background-image: linear-gradient(99deg, #5093fe 0%, #91b9f8 85%);
  // box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.15);
  padding: 10px;
}
.content-c3-xx {
  background: #5093fe;
  border-radius: 8px;
  padding: 10px;
  margin: 7px 0 7px 0;
}
.fz-txt {
  background: #e3425c;
  padding: 5px 15px;
  border-radius: 5px;
  color: #ffffff !important;
}
</style>
